var map = {
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids01.jpg": 4012,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids02.jpg": 9179,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids03.jpg": 3342,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids04.jpg": 6757,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids05.jpg": 5576,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids06.jpg": 8423,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids07.jpg": 6266,
	"./english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids08.jpg": 8321,
	"./english-ai-workshop-for-kids/English+AI Workshop for Kids01.jpg": 154,
	"./english-ai-workshop-for-kids/English+AI Workshop for Kids02.jpg": 8546,
	"./english-ai-workshop-for-kids/English+AI Workshop for Kids03.jpg": 255,
	"./english-ai-workshop-for-kids/English+AI Workshop for Kids04.jpg": 5620,
	"./weekend-ai-for-kids/WeekendAI01.jpg": 2767,
	"./weekend-ai-for-kids/WeekendAI02.jpg": 9152,
	"./weekend-ai-for-kids/WeekendAI03.jpg": 4733,
	"./weekend-ai-for-kids/WeekendAI04.jpg": 3270,
	"./weekend-ai-for-kids/WeekendAI05.jpg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4730;